/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddEmergencyEmailRequest
 */
export interface AddEmergencyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof AddEmergencyEmailRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddEmergencyEmailRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddEmergencyEmailRequest
     */
    language_code: string;
}

/**
 * Check if a given object implements the AddEmergencyEmailRequest interface.
 */
export function instanceOfAddEmergencyEmailRequest(value: object): value is AddEmergencyEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function AddEmergencyEmailRequestFromJSON(json: any): AddEmergencyEmailRequest {
    return AddEmergencyEmailRequestFromJSONTyped(json, false);
}

export function AddEmergencyEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddEmergencyEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'language_code': json['language_code'],
    };
}

export function AddEmergencyEmailRequestToJSON(json: any): AddEmergencyEmailRequest {
    return AddEmergencyEmailRequestToJSONTyped(json, false);
}

export function AddEmergencyEmailRequestToJSONTyped(value?: AddEmergencyEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'language_code': value['language_code'],
    };
}

